module.exports = function(seq, name, id) {
    this.seq = seq;
    this.name = name;
    this.id = id;
    this.meta = {};
};



// WEBPACK FOOTER //
// ./~/biojs-model/src/seq.js